<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card
          flat
          height="100%"
        >
          <!-- top buttons START -->
          <v-card-actions>
            <v-btn
              :loading="loadingButton"
              :disabled="loadingButton"
              @click.native="loader = 'loadingButton'"
            >
              <v-icon class="mr-1">
                mdi-play-speed
              </v-icon>Call
              <span slot="loader">Loading...</span>
            </v-btn>
            <v-btn
              depressed
              @click.native="clear"
            >
              clear
            </v-btn>
          </v-card-actions>
          <!-- top buttons END -->

          <v-card-text>
            <!-- select request START -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  dark
                  outlined
                  color="primary"
                  small
                  v-on="on"
                >
                  {{ selectedRequest }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="request in requests"
                  :key="request.id"
                  @click="selectedRequest=request"
                >
                  <v-list-item-title>{{ request }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- select request END -->

            <!-- URL START -->
            {{ URI }}
            <!-- URL END -->
          </v-card-text>
        </v-card>
      </v-col>
      <!-- URI, Headers, Body tab START -->
      <v-col
        class="mt-3"
        cols="12"
      >
        <v-tabs
          v-model="active"
          background-color="grey lighten-5"
        >
          <v-tab
            v-for="el in parameters"
            :key="el.type"
            ripple
            class="tab-api-parameters"
          >
            {{ el.type }}
          </v-tab>
          <v-tab-item
            v-for="el in parameters"
            :key="el.type"
            class="white"
          >
            <template v-if="el.type !== 'Body'">
              <v-col
                v-if="el.code.length === 0"
                class="pl-3 caption"
              >
                Add a new parameter
                <v-btn
                  icon
                  @click.native="newParam(el.type, 0)"
                >
                  <v-icon
                    small
                    color="grey"
                  >
                    mdi-plus
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                v-for="(param, index) in el.code"
                v-else
                :key="param.id"
                class="pl-3 caption"
              >
                <input
                  v-model="param.key"
                  placeholder="key"
                >
                <input
                  v-model="param.value"
                  placeholder="value"
                >
                <v-btn
                  icon
                  @click.native="newParam(el.type, index)"
                >
                  <v-icon
                    small
                    color="grey"
                  >
                    mdi-plus-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.native="deleteParam(el.type, index)"
                >
                  <v-icon
                    small
                    color="grey"
                  >
                    mdi-delete-outline
                  </v-icon>
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-textarea
                v-model="el.code"
                outlined
                class="tab-api-textarea caption"
                rows="2"
              />
            </template>
            <v-col>
              <v-btn
                depressed
                @click.native="deleteParams(el.type)"
              >
                clear {{ el.type }}
              </v-btn>
            </v-col>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <!-- URI, Headers, Body tab END -->

      <!-- response body START -->
      <v-col
        class="mt-3"
        cols="12"
      >
        <v-card
          flat
          class="hmd-debug"
          color="grey lighten-2"
        >
          <v-card-title
            class="caption"
            placeholder="test"
          >
            <strong>Response Body</strong>
          </v-card-title>
          <v-card-text>
            <vue-json-pretty
              :data="result"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <!-- response body END -->
    </v-row>
  </v-container>
</template>

<script>
  import DatasetService from '../Datastore/services/DatasetService'
  import ApiService from './services/ApiService'
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    components: {
      VueJsonPretty,
    },
    props: {
      api: {},
    },
    data: function () {
      return {
        loader: null,
        loadingButton: false,
        parameters: [
          { type: 'URI parameters',
            code: [
              { key: 'new_item', value: 'null' },
            ] },

          { type: 'Headers',
            code:
              [
                { key: 'new_item', value: 'null' },
              ],
          },

          { type: 'Body', code: 'Add body parameters' },
        ],
        active: null,
        dataset: {},
        error: Number,
        result: 'Add parameters and call the API with the SEND button to see the results.',
        requests: ['GET', 'POST'],
        selectedRequest: 'select a request',
      }
    },
    computed: {
      URI: function () {
        var params = ''
        var param
        var url = this.api.upstream_url
        for (param in this.parameters[0].code) {
          if (param != 0) {
            params += '&'
          }
          params += this.parameters[0].code[param].key + '=' + this.parameters[0].code[param].value
        }
        if (params != '') { return url + '?' + params }

        return url
      },
    },
    watch: {
      loader () {
        if (this.loader) {
          const l = this.loader
          this[l] = !this[l]
          var t = this
          ApiService.call_api(this.api.name, this)
            .then(result => {
              t.result = result.data
              t[l] = false
              t.loader = false
              t.loadingButton = false
            }).catch(function (error) {
              t.result = error.response.data
              t[l] = false
              t.loader = false
              t.loadingButton = false
            })
        }
      },
    },
    methods: {
      editorInit: function () {
        require('brace/mode/python')
        require('brace/mode/sh')
        require('brace/mode/php')
        require('brace/mode/java')
        require('brace/mode/ruby')
        require('brace/theme/chrome')
      },
      handlerChangeCode () {
      },
      call () {
        const l = this.loader
        this[l] = !this[l]
        setTimeout(() => (this[l] = false), 3000)
        this.loader = false
        this.loadingButton
      },
      clear () {
        var i
        for (i in this.parameters) {
          this.deleteParams(this.parameters[i].type)
        }
        this.selectedRequest = 'select a request'
        this.result = 'Add parameters and call the API with the SEND button to see the results.'
      },
      newParam (type, index) {
        this.parameters[this.parameters.findIndex(x => x.type === type)].code.splice(Number(index) + 1, 0, {})
      },
      deleteParam (type, index) {
        this.parameters[this.parameters.findIndex(x => x.type === type)].code.splice(Number(index), 1)
      },
      deleteParams (type) {
        this.parameters[this.parameters.findIndex(x => x.type === type)].code = []
      },
    },
  }
</script>
